import { BorderRight } from "@mui/icons-material";
import { LuSearch } from "@/Components/Icons/Icons";
import { data } from "react-router";
export default {
  row1: [
  {
    column: "column1",
    columnWidth: "55%",
    rows: {
      row1: [
        {
          name: "exportInvoiceOtherInfoExportContractNo",
          label: "Export Contract No /Dt.",
          component: "text-field",
          icon: LuSearch,
          width:"43%"
        },
        {
          name: "exportInvoiceOtherInfoExportContractDate",
          component: "DateSelector",
          width:"43%",
        }
        
      ],
      row2: [
        {
          name: "exportInvoiceOtherInfoNatureOfPayment",
          label:"Nature Of Payment",
          component: "dropdown",
           options:[
                { label: "Not Applicable", value: "Not Applicable" },
                { label: "Letter Of Credit", value: "Letter Of Credit" },
                { label: "Delivery against Acceptance", value: "Delivery against Acceptance" },
                { label: "Direct Payment", value: "Direct Payment" },
                { label: "Advance Payment", value: "Advance Payment" },
              ],
          placeholder:"Not Applicable",
          width: "90%",
          endIconName: "LuChevronDown",          
        },
      ],
      row3: [
        {
          name: "exportInvoiceOtherInfoPaymentPeriod",
          label: "Payment Period",
          component: "text-field",
          width:"100%",
          dataType:"int"
        },
        {
          label: "Days",
          name: "Days",
          component: "typographytext",
          width:"8%",
          sx:{
            mt:2.5
          }
        }
      ],
      row4:[
        {
          name:"AEO Info",
          component: "header",

        }
      ],
      row5:[
        {
          name: "exportInvoiceOtherInfoAEOCode",
          label: "AEO Code",
          component: "text-field",
          width:"90%"
        },
      ],
      row6:[
        {
          name: "exportInvoiceOtherInfoAEOCountry",
          label: "AEO Country",
          component: "text-field",
          icon: LuSearch,
          width:"90%",
          type:"autocomplete",
          endpoint : "getCountry",
        },
      ],
      row7:[
        {
          name: "exportInvoiceOtherInfoAEORole",
          label: "AEO Role",
          component: "text-field",
          width:"90%"
        },
      ]
    },
  },
]
};
